<template>
    <div class="modal-body p-3 px-md-5 py-md-4 text-center" :id="modalId">
        <h3
            class="h4 mb-4"
            v-if="$store.getters.getSubscriptionsStatus === 'idle'"
        >
            {{ acceptText }}
        </h3>

        <!-- Labels -->
        <disabled-labels-warning
            v-if="accepted.promos"
            :accepted-promos="accepted.promos"
        />

        <the-btn
            btn-class="btn-download-labels btn-block btn-primary mb-3"
            text="Generuj wybrane cenówki"
            icon="PriceTags"
            :disabled="isDownloadLabelsBtnDisabled"
            @click.native="downloadLabels"
        >
            <button-spinner class="ml-3" :status="downloadLabelsStatus" />
        </the-btn>
        <div
            class="text-left mt-5 mb-4"
            v-if="accepted.pagination && accepted.pagination.totalRecords > 0"
        >
            <p class="h6 mb-4 text-center">Aktywowano:</p>
            <!-- <div class="table-responsive"> -->
            <page-preloader
                mode="wrapper"
                :isLoading="accepted.status === 'loading'"
            >
                <table class="xt mb-0 table-loader">
                    <thead>
                        <tr>
                            <th></th>
                            <th>Nazwa promocji</th>
                            <th>Sklep</th>
                        </tr>
                    </thead>
                    <tbody style="position: relative">
                        <promotion-shop-status
                            v-for="(promo, idx) in accepted.promos"
                            :key="idx"
                            :promo="promo"
                        ></promotion-shop-status>
                    </tbody>
                </table>
            </page-preloader>
            <the-pagination-small
                v-if="
                    accepted.pagination && +accepted.pagination.totalPages > 1
                "
                class="mt-3"
                :getter="$store.getters.getAcceptedSubscriptionsPagination"
                setter="fetchAcceptedSubscriptions"
            />
            <!-- </div> -->
        </div>
        <div
            class="text-left mt-5 mb-4"
            v-if="errors.pagination && errors.pagination.totalRecords > 0"
        >
            <p class="h6 mb-4 text-center">
                Wystąpiły problemy z następującymi promocjami:
            </p>
            <!-- <div class="table-responsive"> -->
            <page-preloader
                mode="wrapper"
                :is-loading="errors.status === 'loading'"
            >
                <table class="xt mb-0 table-loader">
                    <thead>
                        <tr>
                            <th></th>
                            <th>Nazwa promocji</th>
                            <th>Sklep</th>
                        </tr>
                    </thead>
                    <tbody style="position: relative">
                        <promotion-shop-status
                            v-for="(promo, idx) in errors.promos"
                            :key="idx"
                            :promo="promo"
                            status="error"
                        ></promotion-shop-status>
                    </tbody>
                </table>
            </page-preloader>
            <the-pagination-small
                class="mt-3"
                v-if="errors.pagination && +errors.pagination.totalPages > 1"
                :getter="$store.getters.getErrorSubscriptionsPagination"
                setter="fetchErrorSubscriptions"
            />
            <!-- </div> -->
        </div>
        <router-link
            @click.native="$store.dispatch('toggleModal', false)"
            :to="`/promo-details/${newAcceptedPromoId}`"
            v-if="addNewPromoView"
            class="p-0 text-decoration-none"
        >
            <div class="btn btn-block btn-secondary">
                Przejdź do szczegółów promocji
            </div>
        </router-link>
        <router-link
            v-else
            to="/promo-list/promo-yours"
            class="p-0 text-decoration-none"
        >
            <the-btn
                btn-class="btn btn-block btn-secondary"
                text="Lista aktywowanych promocji"
                icon="Promotions"
                @click.native="onGoToAcceptPromos"
            />
        </router-link>
        <div class="spacer">
            <span>lub</span>
        </div>
        <div class="row">
            <div class="col" v-if="addNewPromoView">
                <div
                    class="btn btn-outline-custom btn-block"
                    @click="onAddAnotherPromo"
                >
                    Załóż kolejną promocję
                </div>
            </div>
            <div
                class="col-12 col-sm mt-3 mt-sm-0"
                :class="{ 'col-sm-auto col-md-6': addNewPromoView }"
            >
                <router-link to="/labels" class="text-decoration-none">
                    <the-btn
                        btn-class="btn btn-outline-custom btn-block"
                        text="Przejdź do listy cenówek"
                        icon="PriceTags"
                        @click.native="$store.dispatch('toggleModal', false)"
                    />
                </router-link>
            </div>
        </div>
    </div>
</template>

<script>
import PromotionShopStatus from '@/components/promotions/PromotionShopStatus'
import DisabledLabelsWarning from '@/components/labels/DisabledLabelsWarning.vue'
import { wtAccepted } from '@/walkthroughs/wtData'

export default {
    components: {
        PromotionShopStatus,
        DisabledLabelsWarning
    },
    props: {
        modalId: {
            type: String
        }
    },
    computed: {
        newAcceptedPromoId() {
            let promoId = null
            const acceptedPromos = this.accepted?.promos
            if (acceptedPromos.length > 0) {
                promoId = acceptedPromos[0]?.id
            } else {
                promoId = this.errors?.promos[0]?.id
            }
            return promoId
        },
        acceptText() {
            let acceptText = ''
            if (this.addNewPromoView) {
                acceptText = `Uruchomiono promocję w ${
                    this.accepted.pagination &&
                    this.accepted.pagination.totalRecords
                } /${this.$options.filters.plurals(
                    this.total,
                    'sklepu',
                    'sklepów'
                )}.`
            } else {
                acceptText = `Aktywowano ${
                    (this.accepted.pagination &&
                        this.accepted.pagination.totalRecords) ||
                    0
                } / ${this.$options.filters.plurals(
                    this.total,
                    'promocję',
                    'promocje',
                    'promocji'
                )}.`
            }
            return acceptText
        },
        addNewPromoView() {
            return this.$router.currentRoute.name === 'add-new-promo'
        },
        total() {
            return this.$store.getters.getProcessedSubscriptionsTotal
        },
        accepted() {
            return this.$store.getters.getProcessedSubscriptionByType(
                'accepted'
            )
        },
        errors() {
            return this.$store.getters.getProcessedSubscriptionByType('error')
        },
        downloadLabelsStatus() {
            return this.$store.getters.getGeneratedLabelsStatus
        },
        isDownloadLabelsBtnDisabled() {
            if (!this.accepted.pagination?.totalRecords > 0) {
                // if there are no promos activated
                return true
            }

            const enabledTypes = this.$store.getters.getLabelPromoTypes

            // if every activated promo is disabled for labels
            return this.accepted.promos?.every((promo) =>
                !enabledTypes.includes(promo.type)
            )
        },
        isWalkThroughActive() {
            return this.$store.getters.getWalkthroughActive
        }
    },
    methods: {
        onAddAnotherPromo() {
            this.$emit('addAnotherPromo')
        },
        onGoToAcceptPromos(e) {
            if (this.accepted.count > 0) {
                e.preventDefault()
                this.$store.dispatch('openConfirmationWindow', {
                    message: 'Na pewno nie chcesz pobrać cenówek?',
                    abortButtonText: 'Zamknij okno',
                    confirmButtonText: 'Generuj wybrane cenówki',
                    confirmationWindowLoadingText:
                        'Trwa przetwarzanie cenówek. Nie zamykaj okna.',
                    abortButtonCallback: () => {
                        this.$store.dispatch('toggleModal', false)
                        this.$router.push('/promo-list/promo-yours')
                    },
                    confirmButtonCallback: () => {
                        this.downloadLabels()
                    }
                })
            } else {
                this.$store.dispatch('toggleModal', false)
            }
        },
        async downloadLabels() {
            try {
                let accepted = {}

                if (this.$store.getters.getWalkthroughActive) {
                    accepted = { promos: wtAccepted }
                } else {
                    this.$store.dispatch('setGeneratedLabelsStatus', 'loading')
                    const processedResponse = await this.$store.dispatch(
                        'getAllProcessedSubsData'
                    )
                    if (processedResponse && processedResponse.data.data) {
                        accepted = processedResponse.data.data.accepted
                    }
                }

                const groups = []

                accepted.promos.forEach(promo => {
                    const group = groups.find(
                        group => group.id === promo.group_id
                    )

                    if (!group) {
                        groups.push({
                            id: promo.group_id,
                            selectedPromoIds: [promo.id]
                        })
                    } else {
                        group.selectedPromoIds.push(promo.id)
                    }
                })

                if (!this.isWalkThroughActive) {
                    await this.$store.dispatch('clearFilters', 'labelGroups')
                }
                this.$store.dispatch('clearLabelGroups', false)
                this.$store.dispatch('unselectAllLabelGroupLabels')
                if (!groups.length) {
                    return this.$store.dispatch(
                        'setGeneratedLabelsStatus',
                        'idle'
                    )
                }

                await this.$store.dispatch('loadSelectedLabelGroups', {
                    groups
                })

                await this.$store.dispatch('toggleModal', false)
                this.$store.dispatch('openModal', {
                    component: 'ModalLabels',
                    classes: 'm-labels'
                })
            } catch (e) {
                console.error(e)
            } finally {
                this.$store.dispatch('setGeneratedLabelsStatus', 'idle')
            }
        }
    },
    beforeDestroy() {
        this.$store.dispatch('resetProcessedSubscriptions')
    }
}
</script>
